import React, { useEffect, useState } from 'react'
import {RMGrnService} from '@gtpl/shared-services/raw-material-procurement'
import { Card, Table, Form, Input, DatePicker, Button, Row, Col, message, Select } from 'antd';
import { CreateInvoiceForVoucher, VoucherVendorReq } from '@gtpl/shared-models/raw-material-procurement';
import { Link } from 'react-router-dom';
const RmVoucherPo = () => {
    const [voucherData, setVoucherData] = useState<any>([])
    const service = new RMGrnService();
    const [form] = Form.useForm();
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [vendors, setVendors] = useState<any>([])
    const [showData, setShowData] = useState(false);
    const [searchForm]=Form.useForm();
    const [invoiceAmount,setInvoiceAmount]=useState(0);

    const onSearchReset=()=>{
        searchForm.resetFields();
        setVoucherData([]);
        setShowData(false);
        form.resetFields();
        setSelectedRowKeys([]);
        setSelectedRows([]);
        setInvoiceAmount(0);
    }


    useEffect(() => {  
        getVendorsForInvoice() 
    }, [])

    const getVendorsForInvoice=()=>{
        service.getVendorsForInvoice().then((res)=>{
            if(res.status){
                setVendors(res.data)
            }else{
                setVendors([])
            }
        }).catch((err)=>{
            console.log(err)
        })
    }

    const rowSelection={selectedRowKeys,
    onChange:(keys:any,rows:any)=>{
        setSelectedRowKeys(keys);
        setSelectedRows(rows);
        const total=rows.reduce((sum,item)=>sum+Number(item.amount||0), 0);
        setInvoiceAmount(total);

    }}

    const formatNumber = (value:any) => {
    const num = Number(value || 0);
    return Number(num.toFixed(3));
    }

    const onSubmit = (values: any) => {
    if (selectedRows.length === 0) {
        message.warning("Please select at least one voucher.");
        return;
    }
    const req = new CreateInvoiceForVoucher();
    // req.invoiceNo = values.invoiceNo;
    req.invoiceDate = values.invoiceDate;
    req.grnIds = selectedRows.map((item: any) => item.grn_id);
    req.vendorId = searchForm.getFieldValue("vendor");
    service.createInvoiceAgainstVoucher(req).then((res: any) => {
        if (res.status) {
            message.success(res.internalMessage);
            form.resetFields();
            setSelectedRowKeys([]);
            setSelectedRows([]);
        onSearch({vendor: searchForm.getFieldValue("vendor")});
        } else {
            message.error(res.internalMessage);
        }
    });
    };

    const onReset = () => {
    form.resetFields();
    setSelectedRowKeys([]);
    setSelectedRows([]);
     setInvoiceAmount(0);
    };

    const Columns=[
        {
            title:'Voucher No',
            dataIndex:'voucherNo',
        },
        {
            title:'Vendor Name',
            dataIndex:'vendorName',
        },
        {
            title:'Quantity',
            dataIndex:'quantity',
            render:(text:any)=>formatNumber(text)
        },
        {
            title:'Amount',
            dataIndex:'amount',
            render:(text:any)=>formatNumber(text)
        }   
    ]

    const onSearch = (values:any)=>{
    const req = new VoucherVendorReq();
    req.vendorId = values.vendor;
    service.getVouchersAgainstFarmerForFinance(req).then(res=>{
        if(res.status){
            setVoucherData(res.data);
            setShowData(true);
        }else{
            setVoucherData([]);
            setShowData(false);
        }
    });
    }

  return (
    <div>
       <Card
      title={<span style={{ color: 'white' }}>RM Vendor PO</span>}
      style={{ margin: 20 }}
      headStyle={{
        backgroundColor: '#69c0ff',
        border: 0,
        textAlign: 'center',
      }}
       extra={
    <Link to="/rm-vendor-po-view">
      <Button type="default">View</Button>
    </Link>
  }>
        <Form form={searchForm} layout="vertical" onFinish={onSearch}
       
        >
        <Row gutter={16} align="bottom">
        <Col span={8}>
            <Form.Item label="Vendor" name="vendor"
                rules={[{required: true, message: "Please select Vendor"}]} >
                <Select
                    placeholder="Select Vendor"
                    allowClear
                    showSearch
                    optionFilterProp="children"
                >
                    {
                        vendors.map((item:any)=>(
                            <Select.Option key={item.farmer} value={item.farmer}>
                                {item.vendorName}
                            </Select.Option>
                        ))
                    }
                </Select>
            </Form.Item>
        </Col>

        <Col
    span={8}
    style={{
        display: 'flex',
        alignItems: 'flex-end',
        gap: 10,
        paddingBottom: 24, 
    }}
>
            <Button
                type="primary"
                htmlType="submit"
                style={{marginRight:10}}
            >
                Submit
            </Button>

            <Button
                danger
                onClick={onSearchReset}
            >
                Reset
            </Button>
        </Col>

    </Row>
</Form>
{
showData && (
    <div>
        <Form form={form} layout="vertical" onFinish={onSubmit}>
    <Row gutter={16} align="bottom">
        <Col span={6}>
    <Form.Item
        label="Invoice Amount"
    >
        <Input
            disabled
            value={formatNumber(invoiceAmount)}
        />
    </Form.Item>
</Col>
{/* 
        <Col span={6}>
            <Form.Item
                label="Invoice Number"
                name="invoiceNo"
                rules={[
                    { required: true, message: 'Please enter Invoice Number' }
                ]}
            >
                <Input placeholder="Enter Invoice Number" />
            </Form.Item>
        </Col> */}

        <Col span={6}>
            <Form.Item
                label="Invoice Date"
                name="invoiceDate"
                rules={[
                    { required: true, message: 'Please select Invoice Date' }
                ]}
            >
                <DatePicker
                    style={{ width: '100%' }}
                    format="DD-MM-YYYY"
                />
            </Form.Item>
        </Col>

<Col
    span={6}
    style={{
        display: 'flex',
        alignItems: 'center',
        marginTop: 30
    }}
>
    <Button
        type="primary"
        htmlType="submit"
        style={{ marginRight: 10 }}
    >
        Submit
    </Button>

    <Button danger onClick={onReset}>
        Reset
    </Button>
</Col>

    </Row>
    </Form>
    <Table
        rowKey="grn_id"
        rowSelection={rowSelection}
        columns={Columns}
        dataSource={voucherData}
        pagination={{ pageSize: 10 }}
    />  
    </div>
            )}    
    </Card>
    </div>
  )
}

export default RmVoucherPo